import { Feature1 } from "./feature-1";
import { Feature2 } from "./feature-2";
import { Feature3 } from "./feature-3";

export const Features = () => {
  return (
    <div
      css={`
        margin: 0 auto;
        padding: 0 20px 77px;
        max-width: 1218px;
        display: flex;
        flex-direction: column;
        gap: 80px;

        @media (min-width: 960px) {
          gap: 128px;
        }
      `}
    >
      <Feature3 />
      <Feature1 />
      <Feature2 />
    </div>
  );
};
